Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterTypeSelectorView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/unapplied/unapplied_date_filter_type_selector']
  className: 'unapplied-filter-value-group'

  initialize: ({range, isChecked, rangeType}) ->
    @range = range
    @rangeType = rangeType
    @isChecked = isChecked
    @name = I18n.t 'customer_visual_mode.filters.date.date_range'
    @type = 'date_range'

  render: ->
    @$el.empty().append @template
      typeValue: @type
      typeName: @name
      isChecked: @isChecked
      range: @range
    @_renderModifier()
    @

  _renderModifier: ->
    @rangeSelectorView?.remove()
    @rangeSelectorView = new CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterTypeSelectorRangeView
      range: @range
      rangeType: @rangeType
    @$('.value-group-modifiers').empty().append @rangeSelectorView.render().el
    @rangeSelectorView.checkUntilNow(@rangeType == CustomerVisualMode.Filters.DateFilter.TYPES.DATE_RANGE_UNTIL_NOW)

  selectedModifier: ->
    @rangeSelectorView?.selectedRange()

  selectedRangeType: ->
    @rangeSelectorView.rangeType()

  togglePickers: ->
    @rangeSelectorView?.togglePickers(@$('.date-filter-type').is(':checked'))
